import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import Portfolio from '../Portfolio';
import CtaStyle2 from '../Cta/CtaStyle2';
import { pageTitle } from '../../helpers/PageTitle';
const portfolioData = [
  {
    href: '/portfolio/portfolio-1',
    imgUrl: '/images/portfolio/home-installation-4.jpg',
    title: 'Solar Flood Light Installation - Karen Residence',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-2',
    imgUrl: '/images/portfolio/public-school-install-4.jpg',
    title: 'Solar Power System - Maragua Public School',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-3',
    imgUrl: '/images/portfolio/street-light-3.jpg',
    title: 'Solar Street Lighting - Kiambu County',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-4',
    imgUrl: '/images/portfolio/irrigation-3.jpg',
    title: 'Solar-Powered Irrigation - Mwea Rice Fields',
    btnText: 'View Project',
  },
];

export default function PortfolioPage() {
  pageTitle('Portfolio');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="We have completed a series of noteworthy projects"
        subTitle="Our Portfolio"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <Portfolio data={portfolioData} />
        <div className="cs_height_75 cs_height_lg_40" />
        <CtaStyle2
          title="Is there a specific project or goal <br />that you have in mind?"
          btnText="Send Message"
          btnUrl="/contact"
        />
        <div className="cs_height_150 cs_height_lg_80" />
      </div>
    </>
  );
}
